var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yd-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        width: "50%",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("template", { slot: "title" }, [
        _c("span", [_vm._v("详细接单情况说明")]),
        _c("span", { staticClass: "color-redFont" }, [_vm._v(_vm._s(_vm.tip))]),
      ]),
      _c("div", { staticClass: "map", attrs: { id: "amapContainer" } }),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v("返 回"),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }